export default "__VITE_ASSET__DZ$Y7pay__"